import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "goober";
import { Button } from "clutch/src/Button/Button.jsx";

import { accountRefs } from "@/app/account.refs.mjs";
import UserIcon from "@/inline-assets/user.svg";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export default function SignInButton() {
  const { isLoggedIn } = useSnapshot(accountRefs);
  const { t } = useTranslation();

  return (
    !isLoggedIn && (
      <Button iconLeft={<UserIcon />} href="/account" className={SignIn()}>
        {t("common:navigation.signIn", "Sign In")}
      </Button>
    )
  );
}

const SignIn = () => css`
  --border: none;
  --bg: var(--shade6);
  color: var(--shade1);
  box-shadow: var(--highlight);

  &:hover {
    --border: none;
    --bg: var(--shade5);
    color: var(--shade0);
  }
`;
